module.exports = __webpack_public_path__ + "console/img/韵达.9a546b16.jpg";